import DocusaurusFooter from '../DocusaurusFooter'
import { LinkToMonitorConfigs } from '@eggplant/routing'
import { Paragraph } from '@eggplant/pattern-library'
import { monitorRunner } from '../../docs-routes'

const MonitorRunner = () =>
  <Paragraph>
    Use the Monitor Runner to run and schedule monitor test executions, and then view results from those test executions.
    <br />
    <br />
    Before you can use the Runner, you must have at least one <LinkToMonitorConfigs>Monitor Config</LinkToMonitorConfigs>.
    <DocusaurusFooter path={monitorRunner} />
  </Paragraph>

export default MonitorRunner
